import { useState } from 'react';

/**
 * Inline, cross-platform label editor (avoids window.prompt, which is a no-op in
 * the Electron desktop build). Commits on Enter or blur, Escape cancels. Used for
 * operator devices and headsets in the Software view.
 */
export default function DeviceLabelEditor({
  label,
  onSave,
  placeholder = 'device name',
  empty = 'unnamed device',
}: {
  label: string | null;
  onSave: (v: string) => void;
  placeholder?: string;
  empty?: string;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(label ?? '');
  if (!editing) {
    return (
      <span
        className="software-device-label"
        onClick={() => {
          setDraft(label ?? '');
          setEditing(true);
        }}
        title="Click to rename"
      >
        {label || <em>{empty}</em>}
      </span>
    );
  }
  const commit = () => {
    setEditing(false);
    if ((draft.trim() || null) !== (label ?? null)) onSave(draft);
  };
  return (
    <input
      className="software-device-label-input"
      autoFocus
      value={draft}
      placeholder={placeholder}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
        if (e.key === 'Escape') setEditing(false);
      }}
    />
  );
}
